export const EtapaEnvioFields = {
    CodSistema: 'sinCodSistema',
    NombreSistema: 'vchNombreSistema',
    IdEtapa: 'intIdEtapa',
    NombreEtapa: 'vchNombre',
    IdEnvioMailExtra: 'intIdEtapaEnvioMailExtra',
    IdGrupo: 'intIdGrupo',
    NombreGrupo: 'vchDescSegGrupo',
    Activo: 'bitActivo',
    NombreSistemaPrincipal: 'vchNombreSistemaPrincipal',
    NombreMostrar: 'vchNombreMostrar'
} as const

export type EtapaEnvioViewDTO = {
    [EtapaEnvioFields.CodSistema]: number
    [EtapaEnvioFields.NombreSistema]: string
    [EtapaEnvioFields.IdEtapa]: number
    [EtapaEnvioFields.NombreEtapa]: string
    [EtapaEnvioFields.IdEnvioMailExtra]: number | null
    [EtapaEnvioFields.IdGrupo]: number | null
    [EtapaEnvioFields.NombreGrupo]: string | null
    [EtapaEnvioFields.Activo]: boolean | null
    [EtapaEnvioFields.NombreSistemaPrincipal]: string
    [EtapaEnvioFields.NombreMostrar]: string
}
